import { TRANSLATION_KEYS } from 'legacy/lut/components/widgets/public/partner360/composedReport/translations/TRANSLATION_KEYS'
import { useMemo } from 'react'

import { Translation } from 'cng-common/features/translations/components/translation'
import { Button } from 'core-components/library/button'

import styles from './ClipboardResultModalContent.module.scss'

interface IProps {
  payloadCount: number
  responseCount: number
  unmatchedValues: string[]
  onClose: () => void
}

export const ClipboardResultModalContent = ({
  payloadCount,
  responseCount,
  unmatchedValues,
  onClose,
}: IProps) => {
  const unmatchedValuesToDisplay = useMemo(() => unmatchedValues.join(', '), [unmatchedValues])

  return (
    <div className={styles.root}>
      <div>
        <Translation span text={TRANSLATION_KEYS.clipboardPayloadCount} />
        :&nbsp;
        <span>{payloadCount}</span>
      </div>
      <div>
        <Translation span text={TRANSLATION_KEYS.clipboardResponseCount} />
        :&nbsp;
        <span>{responseCount}</span>
      </div>
      <div>
        <Translation span text={TRANSLATION_KEYS.clipboardUnmatched} />
        :&nbsp;
        <span>{unmatchedValuesToDisplay}</span>
      </div>
      <div className={styles.btnWrapper}>
        <Button onClick={onClose}>
          <Translation text={TRANSLATION_KEYS.clipboardResultOk} />
        </Button>
      </div>
    </div>
  )
}
